// extracted by mini-css-extract-plugin
export default {"wrapper":"Map_wrapper__-fvFL","title":"Map_title__-D3Ml"};